export default __webpack_public_path__ + "static/media/portfolio-52.5ab2ffa2.jpg";